<div id="crop-health-note-list">
  @if (!loading) {
    @if (notes.length > 0) {
      <div class="notes-container">
        @for (note of notes.slice(0, maxNotesToShow); track note; let i = $index) {
          <app-crop-health-note-item
            [note]="note"
            (getAllNotes)="getAllNotesEvent.emit()"
            (viewNote)="viewNoteEvent.emit($event)" />
          @if (i < notes.length - 1) {
            <div class="divider mt-3"></div>
          }
        }
      </div>

      @if (notes?.length > maxNotesToShow) {
        <div class="seeAllBtn-container">
          <p-button class="seeAllBtn" (onClick)="seeAllNoteChangeEvent.emit()">{{
            'doktar_app.common.see_all' | translate
          }}</p-button>
        </div>
      }
    } @else {
      <div class="empty-note">
        @if (!this.selectedDay?.isCloudly) {
          <div><i class="ph-fill ph-binoculars icon"></i></div>
          <div class="empty-note-message">
            {{ 'doktar_app.services.crop_monitoring.no_registered_notes_found' | translate }}
          </div>
          <div class="empty-note-description">
            {{ 'doktar_app.services.crop_monitoring.no_registered_notes_found_description' | translate }}
          </div>
        } @else {
          <div><i class="ph-fill ph-info icon cloudy"></i></div>
          <div class="empty-note-message">
            {{ 'doktar_app.services.crop_monitoring.cant_add_a_note_for_cloudy_day_title' | translate }}
          </div>
          <div class="empty-note-description">
            {{ 'doktar_app.services.crop_monitoring.cant_add_a_note_for_cloudy_day_description' | translate }}
          </div>
        }
        @if (canCreateNote) {
          <p-button
            class="addNoteBtn"
            severity="primary"
            (onClick)="this.selectedDay?.isCloudly ? null : addModeChangeEvent.emit()"
            [disabled]="this.selectedDay?.isCloudly"
            >{{ 'doktar_app.services.crop_monitoring.add_a_note' | translate }}</p-button
          >
        }
      </div>
    }
  } @else {
    <p-skeleton width="10rem" height="2rem" styleClass="mb-3" />
    <p-skeleton styleClass="mb-3" height="5rem" />
    <p-skeleton styleClass="mb-3" height="10rem" />

    <div class="divider mt-3"></div>
    <p-skeleton width="10rem" height="2rem" styleClass="mb-3" />
    <p-skeleton styleClass="mb-3" height="5rem" />
  }
</div>
